export default {"src":"/_next/static/media/v2-hedaer-arrow-icon.4d714eb6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};